import api from './apiService';

class Parent {
  static checkParent(ci) {
    return api.post('/parents/check_parent', ci);
  }
}

export default Parent;



// WEBPACK FOOTER //
// ./src/api/parentApi.js